// Shared empty result so consumers get a stable reference across renders.
export const NO_POS_DOMAINS = [];
